export default __webpack_public_path__ + "static/media/bloc_blanc_fakechoice_small.dddf85f0.png";